import styled from 'styled-components';
import { Button } from 'antd';

export const MainButton = styled(Button)`
  width: ${(style) => style.width};
  height: ${(style) => style.height};
  margin: ${(style) => style.margin};
  margin-top: ${(style) => style.marginTop};
  margin-right: ${(style) => style.marginRight};
  margin-bottom: ${(style) => style.marginBottom};
  margin-left: ${(style) => style.marginLeft};
  background-color: ${(style) => style.backgroundcolor};
  color: ${(style) => style.color};
  border: ${(style) => style.border};
  border-radius: ${(props) => (props.shape === 'circle' ? 'auto' : '8px')};
`;

export const Div = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;
